import { render, staticRenderFns } from "./subscriptionPage.vue?vue&type=template&id=ec39d02e&scoped=true"
import script from "./subscriptionPage.vue?vue&type=script&lang=js"
export * from "./subscriptionPage.vue?vue&type=script&lang=js"
import style0 from "./subscriptionPage.vue?vue&type=style&index=0&id=ec39d02e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec39d02e",
  null
  
)

export default component.exports